module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tutorial3_c90369.jpg";